import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';
import { LmsLiveQuizTeacherAPIServiceV1 } from '@protos/learning_management/lms.liveQuiz.teacher.apis_connect';
import {
  ResponseStatusCodeFunction,
  lmsTransport,
  lmsTransportWithLogoutHandler,
} from './transports';

export const LmsLiveQuizTeacherAPIServiceV1Client =
  createPromiseClient(LmsLiveQuizTeacherAPIServiceV1, lmsTransport);

export const useLmsLiveQuizTeacherAPIServiceV1ClientWithStatusCodeHandler =
  (
    options: Partial<ConnectTransportOptions>,
    responseStatusCodeFunction: ResponseStatusCodeFunction
  ) =>
    createPromiseClient(
      LmsLiveQuizTeacherAPIServiceV1,
      lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
    );
